<template>
	<div class="returnOrders">
		<Customer-Order :bindOrder.sync="bindOrder" :textDesc="textDesc"  @updataItem="updataItem(arguments)"></Customer-Order>
		<!-- 查看物流 -->
		<el-dialog
		  :title="$t('other.a85')"
		  size="mini"
		  :visible.sync="LogisticsWindow"
		  width="60%"
		 >
		 <div class="logistics-header">
			   <div>{{$t('other.a86')}}{{LogisticsInfo.tracking_number}}</div>
				<div>{{$t('other.a87')}}{{LogisticsInfo.order_sn}}</div>
		 </div>
		 <div class="logistics-header">{{$t('other.a824')}}：{{returnCause(LogisticsInfo.logistics_status)}}</div>
		  <el-table
		       :data="LogisticsInfo.tracking_info"
		       height="250px"
			   >
		       <el-table-column
			   :label="$t('other.a89')"
		         width="200">
				 <template slot-scope="scope">
				 	{{getLocalTime(scope.row.update_time)}}
				 </template>
		       </el-table-column>
		       <el-table-column
			   :label="$t('other.a90')"
		         width="600">
				 <template slot-scope="scope">
				 	{{scope.row.description}}
				 </template>
		       </el-table-column>
		 
		   </el-table>
		   
		  
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="LogisticsWindow = false">{{$t('other.a106')}}</el-button>
		    <el-button type="primary" @click="LogisticsWindow = false">{{$t('other.a279')}}</el-button>
		  </span>
		</el-dialog>
		<!-- 卖家确认退货操作类型: -->
		<el-dialog
		  :title="$t('other.a816')"
		  size="mini"
		  :visible.sync="returnInfo"
		  width="60%"
		 >
		 <div v-if="options.type === 30 && userPos === 'SELLER'" style="color: orangered;">
		 	<div>{{$t('other.a579')}}：{{returnStur.returnMessage}}</div>
		 </div>
		 <div v-if="type === 31  " class="retrun-reasonr sellerMessage">
		 	<div>{{$t('other.a499')}}：{{returnStur.sellerMessage}}</div>
		 </div>
		 <div style="margin-bottom: 20px;">
			    <el-table
			       :data="returnStur.returnItems"
				   height="300px"
			       style="width: 100%">
				   <el-table-column
				   	 v-if="userPos ==='STORE'"
				     :label="$t('other.a812')"
				     width="100"
					 :show-overflow-tooltip="true"
					 >
					 <template slot-scope="scope">
					 	<span style="color: red;">{{auditType(scope.row.sellerReturnType)}}</span>
					 </template>
				   </el-table-column>
				   <el-table-column
				     :label="$t('other.a66')"
				     width="80" 
					 >
					 <template slot-scope="scope">
						 <img v-image-preview style="width: 60px;height: 60px;" :src="scope.row.image"  />
					 </template>
				   </el-table-column>
			       <el-table-column
			         prop="itemName"
			         :label="$t('other.a817')"
			         width="180"
					 :show-overflow-tooltip="true"
					 >
			       </el-table-column>
			       <el-table-column
			         prop="itemSku"
			         label="SKU"
					  :show-overflow-tooltip="true"
			         width="120">
			       </el-table-column>
				   <el-table-column
				     :label="$t('other.a813')"
					 :show-overflow-tooltip="true"
				     >
					 <template slot-scope="scope" >
						<el-input-number v-if="scope.row.sellerReturnType === 2"  style="width: 100px;"   size="mini"  type="number" onkeyup="value=value.replace(/[^\d]/g,'')"  v-model="scope.row.variationQuantityPurchased"  :min="0"  ></el-input-number>
					 </template>
				   </el-table-column>
				   <el-table-column
				    
				     :label="$t('other.a33')"
				     width="180"
					 :show-overflow-tooltip="true"
					 >
					 <template  slot-scope="scope">
						<el-radio-group v-if="userPos === 'SELLER'" style="display: flex;flex-direction: column;" size="mini" v-model="scope.row.sellerReturnType">
							<div style="display: flex;">
								<el-radio style="margin-bottom:20px" size="mini" :label='2'>{{$t('other.a806')}}</el-radio>
							</div>
						  <el-radio style="margin-bottom:20px" size="mini" :label='1'>{{$t('other.a805')}}</el-radio>
						 <el-radio style="margin-bottom:20px" size="mini" :label='3'>{{$t('other.a807')}}</el-radio>
						</el-radio-group> 
						
					 </template>
				   </el-table-column>
			     </el-table>
		
		 </div>
		 <div>
			 <el-input
			 v-if="userPos ==='SELLER'"
			   type="textarea"
			   :placeholder="$t('other.a819')"
			   v-model="textarea"
			   maxlength="120"
			   show-word-limit
			 >
			 </el-input>
			 <el-input
			 v-if="userPos ==='STORE'"
			   type="textarea"
			   :placeholder="$t('other.a820')"
			   v-model="textarea"
			   maxlength="120"
			   show-word-limit
			 >
			 </el-input>
			 
		 </div>
		 
		  
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="returnInfo = false">{{$t('other.a106')}}</el-button>
		    <el-button v-if="userPos === 'SELLER'" type="primary" @click="comfirm">{{$t('other.a279')}}</el-button>
			<el-button v-if="userPos === 'STORE'" type="primary" @click="StoreComfirm">{{$t('other.a279')}}</el-button>
		  </span>
		</el-dialog>
		<!-- 查看退货包裹 -->
		<el-dialog
		  :title="$t('other.a811')"
		  :visible.sync="returnbag"
		  width="60%"
		  >
		  <div class="returnbag-box">
			  <div>
				  <div v-if="!returnImag.length">{{$t('other.a823')}}</div>
				  <div style="display: flex;" v-else>
					  <div   style="width:80px;height: 80px;padding: 0 5px;" v-for="(item,index) in returnImag" :key="index">
					  		<img v-image-preview style="width: 100%;" :src="item.imageUrl">
					  </div>
				  </div>
			  </div>
			   <el-table
			        :data="viewReturnDescData.items"
			        style="width: 100%"
					height="150px"
					>
			        <el-table-column
			          prop="date"
			          :label="$t('other.a66')"
			          width="60">
					  <template slot-scope="scope">
					  		<img v-image-preview :src="scope.row.image" alt="" style="width: 50px;height: 50px">
					  </template>
			        </el-table-column>
			        <el-table-column
			          prop="itemName"
			          :label="$t('other.a30')"
					  :show-overflow-tooltip="true"
			          width="180">
			        </el-table-column>
					<el-table-column
					  :show-overflow-tooltip="true"
					  label="sku"
					  width="150">
					  <template slot-scope="scope">
					  		<span>{{scope.row.itemSku}}</span>
					  </template>
					</el-table-column>
			        <el-table-column
			        
					  :show-overflow-tooltip="true"
					  width="120"
			          :label="$t('other.a812')">
					  <template slot-scope="scope">
					  		<span>{{auditType(scope.row.storeReturnType)}}</span>
					  </template>
			        </el-table-column>
					<el-table-column
					  prop="storeReturnNum"
					  :show-overflow-tooltip="true"
					  width="120"
					  :label="$t('other.a813')">
					</el-table-column>
			      </el-table>
				  <div>
					  <p style="padding:5px 0;color:red" v-if="viewReturnDescData.returnMessage">{{$t('other.a579')}}：{{viewReturnDescData.returnMessage}}</p>
					  <p style="padding:5px 0;color:red" v-if="viewReturnDescData.sellerMessage">{{$t('other.a499')}}：{{viewReturnDescData.sellerMessage}}</p>
					  <p style="padding:5px 0;color:red" v-if="viewReturnDescData.storeMessage">{{$t('other.a579')}}：{{viewReturnDescData.storeMessage}}</p>
				  </div>
			  
		  </div>
		    <div style="text-align: right;">
				<el-button type="primary" @click="returnbag = false">{{$t('other.a729')}}</el-button>
			</div>
		    
		 
		</el-dialog>
		
		<div style="font-size: 20px;" >{{$t('other.a915')}}</div>
		<div style="margin: 20px 0;display: flex;"  v-for="(item,index01) in buttonList" :key="index01">
				<div >{{item.desc}}</div>
				<span class="filterbox" >
					<span class="storeBox"  :class="{'ttpactive':ttp.isActive  }"  :key="index"  v-for="(ttp,index) in item.value" @click="handleBtn(item,ttp.key,index,index01)">{{conversion(ttp.key,index01)}} <span v-show=" index01 !== 0 && userPos == 'SELLER'">({{ttp.count}})</span></span>
					
				</span>
		</div>
		<div class="block">
			{{$t("other.a867")}}：
			<el-input
			  style="width: 250px;"
			  :placeholder="$t('other.a868')"
			  clearable
			  v-model="ordersnText">
			</el-input>
			<el-button type="primary" @click="getOrderSn()">{{$t('other.a916')}}</el-button>
		</div>
		<div class="nodata" v-if="!orderlist.length" >--{{$t('pendingorder.nodata')}}--</div>
		 <div class="order-wrapper" v-else>
			<div class="order-list-item" v-for="(item,index) in orderlist"  :key="index">
				<div class="list_desc">
					<span  class="seller">{{$t('other.a87')}}{{item.orderId}}</span>
					<span   class="seller">{{$t('problemorder.order_status')}}：{{item.orderStatus}}</span>
					<span   class="seller" >{{$t('other.a837')}}：{{item.storeId ? getStoreName(item.storeId) : $t('other.a920')}}</span>
					<span class="seller" v-if="item.canReturn == 0 && !item.storeId "><el-button size="mini" type="primary" @click="reBind(item)">{{$t('other.a917')}}</el-button></span>
				</div>
				<div class="return-desc">
					<div class="return-item" >
						<!-- 如果查询出来的订单是取消类型的订单，显示 -->
						<div  class="return-wrpaer">
							<div class="return-item-list" v-for="(childrenItem,indexlll) in item.returnItems" :key="indexlll">
								<div style="display:flex">
									<span class="pic-box" ><img v-image-preview :src="childrenItem.image"  /></span>
									<div class="pic-box-desc">
										<div class="item_desc">{{childrenItem.itemName}}</div>
										
										<div class="item_desc" style="color:#000;font-size:10px;margin-top:10px">variationSku:{{childrenItem.variationSku}}</div>
										<div class="item_desc" style="color:#000;font-size:10px;margin-top:10px">variationName:{{childrenItem.variationName}}</div>
										
										
									</div>
									<div class="item_desc" style="color:red"      v-if="!childrenItem.storeItem && childrenItem.itemKey!=='DXS|EMPTY_ORDER'">
											{{$t('other.a918')}}
											<span style="color:#409eff;margin-left:20px;cursor: pointer;" @click="bindProduct(item,childrenItem)">{{$t('other.a918')}}</span>
									</div>
									<div style="width:300px" v-if="childrenItem.storeItem">
										<div v-if="childrenItem.storeItem && childrenItem.platform !=='DXS'">
											<span>{{$t('other.a226')}}{{childrenItem.storeItem.cusCode}} ( {{childrenItem.storeItem.component ? $t('other.a251') : $t('other.a252')}})</span>
										</div>
										<div v-if="childrenItem.storeItem && !childrenItem.storeItem.component && childrenItem.storeItem.children"
										v-for="(ccp,indexCpp) in childrenItem.storeItem.children" :key="indexCpp"
										
										>
											<a :title="ccp.skuName"><div class="skuname">{{$t('other.a920')}}：{{ccp.skuName}}</div></a>
											<div>{{$t('other.a633')}}：x{{ccp.rate*childrenItem.variationQuantityPurchased}}</div>
										</div>
										<div v-if="childrenItem.storeItem && childrenItem.storeItem.component">
											<a :title="childrenItem.storeItem.skuName"><div class="skuname">{{$t('other.a920')}}：{{childrenItem.storeItem.skuName}}</div></a>
											<div>{{$t('other.a633')}}：x{{childrenItem.variationQuantityPurchased}}</div>
										</div>
										
									</div>
									<div >
									<div style="margin-bottom:5px;color:rgb(245, 34, 45)" v-show="options.orderType !== 1">{{$t('other.a921')}}：
										<span >{{auditType(childrenItem.sellerReturnType)}}</span>
									</div>
									<div style="margin-bottom:5px;color:rgb(245, 34, 45)" v-show="options.orderType !== 1 && childrenItem.sellerReturnType == 2">{{$t('other.a813')}}：
										<span >{{childrenItem.sellerReturnNum}}</span>
									</div>
									<div v-if="item.returnType == 3" style="margin-bottom:5px;color:rgb(42, 165, 21)" v-show="options.orderType !== 1">{{$t('other.a922')}}：
										<span >{{auditType(childrenItem.storeReturnType)}}</span>
									</div>
									<div v-if="item.returnType == 3" style="margin-bottom:5px;color:rgb(42, 165, 21)" v-show="options.orderType !== 1 && childrenItem.sellerReturnType == 2">{{$t('other.a813')}}：
										<span >{{childrenItem.storeReturnNum}}</span>
									</div>
								</div>
								</div>

								
								
							</div>

							
						</div>

						<div class="retrun-reasonr-btn" >
									<el-button size="mini" style="width:150px; margin:0 0 5px 10px;" type="primary"  @click="handlereturnbag(item)">{{$t('problemorder.return_package')}}</el-button>
									
									<el-button size="mini" style="width:150px" type="danger" v-if="options.orderType === 1"  @click="sellerComfirm01(item)">{{$t('problemorder.confirmed_by_seller')}}</el-button>
									<el-button size="mini" style="width:150px" type="danger" v-if="options.orderType === 2  && userPos === 'STORE'"   @click="storeComfirm01(item)">{{$t('problemorder.be_processed_by_store')}}</el-button>
									<el-button size="mini" style="width:150px" type="danger" v-if="options.orderType === 2  && userPos === 'SELLER'"  @click="sellerComfirm02(item)">{{$t('problemorder.be_processed_by_store')}}</el-button>
									<el-button size="mini" style="width:150px; margin-top:5px" type="primary"  @click="deleteItem(item,index)">{{$t('other.a312')}}</el-button>
								</div>
					
						
					</div>
					<div class="item_desc_ppdf">{{$t('other.a579')}}：{{item.receivedMsg ? item.receivedMsg : $t('other.a354')}}</div>
					<div class="item_desc_ppdf">{{$t('other.a499')}}：{{item.sellerMsg ? item.sellerMsg : $t('other.a354')}}</div>
				</div>
			</div>
		 </div>
				<!-- 分页器 -->
				<div class="Pager">
					<el-pagination
					style="background-color: #fff;"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="page"
					:page-sizes="[15, 20, 30, 50]"
					:page-size="offset"
					layout=" total,sizes, prev, pager, next, jumper"
					:total="orderCount">
					</el-pagination>
				</div>
	</div>
</template>

<script>
		import {mapState, mapActions , mapMutations} from 'vuex'
		import api from '../../../api/api.js'
		import order from '../../../api/moudles/order.js'
		import newOrders from '../../../api/moudles/newOrders'
		import utils from '../../../utils/utils.js'
		import {JudegeBindStore} from '../../../utils/toolFun.js'
		import CustomerOrder from '../pendingorder/components/dialog'

	export default{
		data(){
			return {
				buttonList:[{
					isActive:0,
					desc:this.$t("other.a923"),
					value:[{
						isActive:true,
						key:1,
						count:0,
					},{
						key:2,
						isActive:false,
						count:0,
					},{
						key:3,
						isActive:false,
						count:0,
					}]
				}],
				options:{
					offset: 15,
					page: 0,
					shopIds: 0,
					orderType:1,
					sortType: 1,
					platform: null,
					start:null,
					end:null,
					storeIds:[],
					userId: '',
				},
				falg:[0,1],
				itemKey:0,
				orderlist:[],
				errorList:[],
				bindError:false,
				ordersnText:'',
				orderCount:0,
				textDesc:null,
				warehouselist:[],
				shopeeId: [{
				          value: ' ',
				          label: this.$t("other.a843")
				        }
					],	
					allstore:[
						{
							value:'',
							label:this.$t('shippedorder.all_store')
						}
					],	
					store:'',
				shopeeIdvlue:' ',
				warehouseValue:'',
				value: '',
				queryDate: '',
				shopId:'',
				currentPage1: 1,
				dialogVisible: false,
				shopList: JSON.parse(localStorage.getItem('shopId')),
				start_time:'',
				end_time:'',
				dialogVisible01: false,
				orderSn:'',
				orderShopid:'',
				batchReview:[],
				value1: true,
				value2: true,
				labelCCP:false,
				isReview:false,
				input10:'',
				radio7: '1',
				showbox:'1',
				ttp:true,
				pagesize:15,
				currentPage:0, //当前页码
				offset:15, //每页显示条数
				type:13,
				returnOrder:false,
				dialogVisible_returnorder:false,
				return_desc_order:[],
				LogisticsWindow:false,  
				textarea:'',
				returnInfo:false,
				returnStur:'',
				isIndex:0,
				radio2:0,
				sellerOperaList:[],
				shangjianNum:0,
				returnInfo88:false,
				returnItem:null,
				activeName:'first',
				isShopee:true,
				returnbag:false,
				returnImag:[],
				sellerReturnNum:0,
				viewReturnDescData:'',
				bindParams:{},
				bindOrder:false,
				
		
			}
		},
		computed:{
			...mapState({
				userId: state=>state.login.userInfo.userId || '',
				vipLevel:state=>state.login.userInfo.vipLevel || '',
				userPos: state=>state.login.userInfo.userPos,
				LogisticsInfo: state => state.order.LogisticsInfo,
				
			}),
			
		
		
		},
		components:{
			CustomerOrder
		},
		watch:{
			userId(){
				this.options.userId=this.userId
			},
			ordersnText(){
				if(!this.ordersnText){
					this.options.orderId=''
					this.getOrderData(this.options)
				}
			}
		},
		created(){
			this.init()
			
		},
		
		methods:{
			...mapActions('processed',[
				'getProcessedOrderSn',
				'getProcessedOrderInfo',
				'getIDacountProcessedList',
				'getPackagedOrderByStore',//仓库帐号下猎取已出库出库的订单
				'setPackaged',
				'getProcessedOrders',
				'getProcessedOrdersByStore',
				'getLogisticsBystore',
				'getLogisticsByseller',
				'getProcessedOrderBySeller',
				'getProcessedOrderByStore',
				'getOrderByOrderId'
			]),
			
			...mapActions('order', [
				'getProblemorder',
				'getOrdersBytrickNo',
				'viewLogistics',
				'sellerComfirm',
				'storeComfirm',
				'getOrdersBytrickNo_return',
				'getOrderCountTotal',
				'queryReturnOrderNum'
				
			]),
			
			...mapActions('print',[
			   'getParams',
			   'getAllOrders',
			   'getStoreOrders',
						   
			]),
		
			
			...mapMutations('processed',[
				'SET_PROCESSED_ORDER_LIST',
			]),

			bindProduct(outerItem,item){
				if(item.storeItem){
					let storeName=item.storeItem.storeName
					let itemSku=item.storeItem.itemSku
					let skuName=item.storeItem.skuName 
					this.textDesc=this.$t('other.a734')+storeName+'/'+this.$t('other.a735')+":"+itemSku+ "/"+this.$t('other.a736')+":"+skuName
				}else{
					this.textDesc=this.$t('other.a737')
				}
				
				console.log(this.textDesc)
				console.log(item)
				this.bindParams.itemKey=item.itemKey,
				this.bindParams.shopId=outerItem.shopId,
				this.bindParams.userId=this.userId
				this.bindOrder=true
				console.log(this.bindParams)

			},
			
			conversion(value,index){
				if(index == 0 ){
					if(value == '') {
						return this.$t('other.a358')
					}
					return utils.showshopNameByshopIdOne(value)
				}else if(index == 1) {
					let obj={
						1:this.$t('other.a924'),
						2:this.$t('other.a925'),
						3:this.$t('other.a926'),
					}
					
					return obj[value]
				}
			},
			
			handleBtn(item,value,index01,index){
				console.log(item,value,index01,index)
				this.buttonList[index].value.forEach(p => {
					p.isActive=false
				})
				this.buttonList[index].value[index01].isActive=true
				
				if(index == 0){
					this.options.shopIds=value ? [value] : JSON.parse(localStorage.getItem('userInfo')).shopIds
				}

				if(index == 1){
					this.options.orderType=value
				}

				console.log(this.options)
				this.getOrderData(this.options)
				
			},
			getOrderSn(){
				this.options.orderId=this.ordersnText
				this.getOrderData(this.options)
			},

			updataItem(data){
				console.log('data',data)
				this.bindParams.cusCode=Number(data[0].itemKey.split('|')[1])
				console.log(this.bindParams)
				newOrders
				.bindByItemKey([this.bindParams])
				.then(res => {
				if(res.code === 200 ){
				console.log('desc',res.data)
				if(res.data.error.length > 0){
					this.errorList=res.data.error
					this.bindError=true
				}
				if(res.data.error.length  == 0){
					this.$message.success(this.$t('other.a733'))
				}

				this.bindOrder=false
			
				}else{
				this.$message.warning(res.msg)
				}
				})
			},
			
			init(){ 
				if(this.userPos === 'STORE'){
				this.req_params.storeIds=utils.getAllwarehouse().map(p => {return {Name:p.label,Id:p.value}})
				this.req_params_copy.storeIds=utils.getAllwarehouse().map(p => {return {Name:p.label,Id:p.value}})
				this.allStoreId=utils.getAllwarehouse().map(p => {return p.value}).slice(1)
				this.req_params.storeIds=this.allStoreId
				
				}else if(this.userPos === 'SELLER'){
					this.options.userId=this.userId
					this.options.shopIds=JSON.parse(localStorage.getItem('userInfo')).shopIds
					this.options.storeIds=JSON.parse(localStorage.getItem('userInfo')).storeIds
					this.options.isHidden=0
					this.options.hasPdf=true
					this.falg[0]=''
					this.buttonList.unshift({
						isActive:0,
						desc:this.$t('other.a359')+'：',
						value:utils.getAllshop().map(p => {return p.value}).slice(1).map(p => {
							return {
								key:p,
								isActive:false,
								count:0
							}
						})
					})
					
					this.buttonList[0].value.unshift({
						isActive:true,
						key:"",
						count:0
					})
					this.getOrderData(this.options)
					console.log(this.buttonList)
				}
			},
			handleSizeChange(val) {
				this.offset=Number(`${val}`)
				this.options.offset=this.offset
				this.handleCurrentChange()
			 },
			handleCurrentChange(val) {
				console.log(`${val}`)
				let num=`${val}` == 'undefined' ?  0 : (Number(`${val}`) -1)
				this.page=this.offset*num
				console.log(this.page)
				this.options.page=this.page
				this.getOrderData(this.options)
			},

			reBind(item){
				console.log(item)
				let  params={
					userId:this.userId,
					orderId:item.orderId
				}

				order
				.bindReturnOrder(params)
				.then(res => {
				if(res.code === 200 ){
				console.log('desc',res.data)
				this.getOrderData(this.options)
				this.$message.success(this.$t('other.a475'))
				}else{
				this.$message.warning(res.msg)
				}
				})

				console.log(params)
			},
			returnCause(ttp) {
				const status = {
					'LOST_PARCEL': this.$t("other.a114"),
					'LOGISTICS_DELIVERY_FAILED': this.$t("other.a115"),
					'Failed Delivery':this.$t("other.a115"),
					'LOST_PARCEL':this.$t("other.a114"),
					'Parcel lost in transit. The eligible compensation has been credited into your seller wallet.':this.$t("other.a114"),
					'LOGISTICS_ISSUE':this.$t("other.a139"),
					'Logistic Issue':this.$t("other.a139"),
					'Delivery service provider reported that the parcel has been lost.':this.$t("other.a114"),
					'FRAUD_CASE':'FRAUD_CASE',
					'':this.$t("other.a140"),
					
					
					
				}
				return status[ttp]
			},
			getOrderData(payload){
				order
				.queryReturnOrder(payload)
				.then(res => {
					if(res.code === 200) {	
						console.log("退货订单",res.data)

						this.orderlist=res.data.orders
						this.orderlist.forEach(p => {
							p.canReturn=JudegeBindStore(p.returnItems)
						})
						this.orderCount=res.data.count
						res.data.otherCount.forEach(p => {
							this.buttonList[1].value.forEach(k => {
								if(p.type == k.key){
									k.count=p.count
								}
							})
						})
						
						console.log(this.buttonList)
					}
				})	
			},
			storeComfirm01(item){
				this.returnInfo=true
				this.returnStur=item
			},
			checkReturn(item){
				console.log(item)
				this.returnItem=item
				this.returnInfo88=true
			},
			
			returnGoods(){
				console.log(this.textarea)
				console.log(this.store)
				if(!this.store) {
					this.$message({
						message:this.$t("other.a844"),
						type:'error'
					})
					return
				}
				
				this.returnItem.returnStore=this.store
				this.returnItem.returnMessage=this.textarea
				
			
				console.log('确认收货信息',this.returnItem)
				this.returnInfo88=false
			},
			
			comfirm(item){
				let params={
					orderId:this.returnStur.orderId,
					platform:this.returnStur.platform,
					receivedMsg:this.returnStur.receivedMsg,
					sellerMsg:this.textarea,
					returnItems:this.returnStur.returnItems,
					shopId:this.returnStur.shopId,
					storeId:this.returnStur.storeId,
					userId:this.userId
				}
				
				let ttp=false
				let ttp1=false
				this.returnStur.returnItems.forEach(p => {
					if(p.sellerReturnType === 2 ) {
					   p.sellerReturnNum = p.variationQuantityPurchased
					}
				})

				this.returnStur.returnItems.forEach(p => {
					if(p.sellerReturnType == 0){
						ttp1=true
					
					}
				})
				if(ttp1){
					this.$message.error(this.$t('other.a927'))
					return
				}
			
					
					console.log(params)
					order
					.sellerComfirm(params) 
					.then(res => {
						if(res.code === 200) {
							this.$message.success(this.$t('other.a928'))
							this.getOrderData(this.options)
							this.returnInfo=false
							this.radio2=0
						}
					})
					
				
				
				
				
			},
			sellerComfirm01(item){
				
				if(this.userPos === "STORE") {
					this.$message.warning(this.$t("other.a846"))
					return
				}

				if(!item.storeId){
					this.$message.warning(this.$t('other.a929'))
					return
				}

				this.returnStur=item
				this.returnInfo=true
				console.log(item)
			},

			sellerComfirm02(item){
				if(this.userPos === "SELLER") {
					this.$message.success(this.$t("other.a847"))
					return
				}
				this.returnStur=item
				this.returnInfo=true
				console.log(item)
			},

			viewLogistics01(item) {
				this.viewLogistics(item)
				this.LogisticsWindow=true
			},

			deliveryStore(num){
				if(num==null){
					return this.$t("other.a848")
				}
				let ttp=null
				this.warehouse.forEach(item => {
					if(item.storeId === num ) {
						ttp=item
					}else{
						ttp =item
					}
				})
				
				return ttp.storeName + '(' + ttp.userName + ")"
				
			},
			
			saveItem(ttp,ccp){
				this.dialogVisible01=true
				this.orderSn=ttp
				this.orderShopid=ccp
			},
			getTime(time){
				if(!time) {
					return this.$t("other.a354")
				}
				let ttp=time.slice(0,time.indexOf('T'))
				let ccp=time.slice(time.indexOf('T')+1,time.indexOf('.'))
				return ttp+ ' ' + ccp
			},
			getStatus(item){
				let ttp=utils.conversionStatus(item)
				return ttp
			},
			setNowTimes (atp){
				let myDate = atp
				    // console.log(myDate)
				    let wk = myDate.getDay()
				    let yy = String(myDate.getFullYear())
				    let mmp = myDate.getMonth() + 1
					let mm = String(mmp < 10 ? '0' + mmp : mmp) 
				    let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
				    let hou = String(myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours())
				    let min = String(myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes())
				    let sec = String(myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds())
				    let weeks = [this.$t("chat.Sunday"), this.$t("chat.Monday"), this.$t("chat.Tuesday"), this.$t("chat.Wednesday"), this.$t("chat.Thursday"), this.$t("chat.Friday"), this.$t("chat.Saturday")]
				    let week = weeks[wk]
				    let nowDate = yy + '-' + mm + '-' + dd
				    let nowTime = hou + ':' + min + ':' + sec
				    let nowWeek = week
				    let ccp = nowDate + ' ' + nowTime + ' ' + nowWeek
					return  ccp.substring(0,11)
			},
			
			chooseOrder(numn){
				this.SUCCESS_GET_DATA_OPEN()
			
				let start=this.setNowTimes(this.queryDate[0])
				let end=this.setNowTimes(this.queryDate[1])
				
				const params={
					userId: this.userId,
					start: start,
					end: end,
				}
				
				
				this.SET_ORDERLIST_NULL()
				// this.getunprocessOrder(params)
				
				
			},
			getLocalTime(tiem) {
				//将时间戳（十三位时间搓，也就是带毫秒的时间搓）转换成时间格式
				// d.cTime = 1539083829787
				let  ttp=parseInt(tiem) * 1000
				let date = new Date(ttp);
			    let Y = date.getFullYear() + '-';
				let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				let D = date.getDate() + ' ';
				let h = date.getHours() + ':';
				let m = date.getMinutes() + ':';
				let s = date.getSeconds();
				return Y + M + D + h + m + s;
			
				console.log(date)
			},
			//订单筛选
			choice(num) {
				console.log(num)
				this.QUESTION_ORDER_CHOOSE(num)
			},
			choiceshopId () {
				console.log(this.shopeeIdvlue)
				this.CHOOSE_SHOPID(this.shopeeIdvlue)
				
			},
			accp(){
				console.log(this.returnList)
				console.log(this.orderlist)
				console.log(this.deliverfailedCount)
				
			},
			auditType(num){
				console.log(num)
				const ttp={
					1:this.$t('other.a805'),
					2:this.$t('other.a806'),
					3:this.$t('other.a807')
				}
				console.log(ttp[num])
				return ttp[num]
			},
			 changeImgURL(url){
				
				 if(url === ' ') {
					 return
				 }else{
					 let baseUrl="https://s-cf-th.shopeesz.com/"
					 let index=url.indexOf("/file/")
					 let ttp=url.slice(index)
					 return baseUrl+ttp
				 }
				
				
			 },

			 getStoreName(id){
				 return utils.showStoreName(id)
			 },
			
			
			 gotosearch(){
				const params={
					orders:this.input10,
					type:9
				}
			 	this.getOrdersBytrickNo(params)
				
			 },
			 gotosearch01(){
			 				const params={
			 					orders:this.input10,
			 					type:9
			 				}
			 	this.getOrdersBytrickNo_return(params)
			 				
			 },
			 changebtn_STORE(num){
				 this.isIndex=num
				 this.type=num
				 const params={
				 	offset:this.offset,
				 	page:this.currentPage,
				 	userId:this.userId,
				 	type:this.type,
				 	shopId:'',
				 }
				 
				  this.getProblemorder(params)
			 },
			 //获取退货管理 已取消,退货,申请取消的订单
			 changebtn(num){
				 if(this.isShopee) {
					 console.log(this.shopeeIdvlue)
					if(num){
						this.isIndex=num
						this.type=num
					}
					 const params={
					 	offset:this.offset,
					 	page:this.currentPage,
					 	userId:this.userId,
					 	type:this.type,
						sortType:1,
					 	shopId:this.shopeeIdvlue
					 }
					 console.log(params)
					 this.getProblemorder(params)
				 }else{
					 this.type=num
					 const params={
					 	offset:this.offset,
					 	page:this.currentPage,
					 	userId:this.userId,
					 	type:this.type,
					 	shopId:this.shopeeIdvlue
					 }
					 
					 this.getLazadaOrderByuserid(params)
				 }
				
				
					
			 },
			 handlereturnbag(item){
			 	this.viewReturnDescData=item
			 	this.returnbag=true
			 	console.log(item)
			 	this.returnImag=item.returnOrderImages
			 	console.log('退货详情',this.viewReturnDescData)
			 },

			 deleteItem(item,index){
				 console.log(item)
				 this.$confirm(this.$t('other.a608'), this.$t("other.a142"), {
				 confirmButtonText: this.$t('other.a235'),
				 cancelButtonText: this.$t('other.a146'),
				 type: 'warning'
				 }).then(() => {
					 newOrders
					 .alertReturnOrders({
						 isHidden:1,
						 isSelectAll:false,
						 orderIds:[item.orderId],
						 orderType:1,
						 userId:this.userId,
					 })
					 .then(res => {
					 if(res.code === 200 ){
					 console.log('desc',res.data)
					 this.$message.success(this.$t('other.a800'))
					 this.getOrderData(this.options)
					 this.orderlist.splice(index,1)
					 }else{
					 this.$message.warning(res.msg)
					 }
					 })
				 })
			 },
			 changebtn01(){			
				 const params={
					offset:this.offset,
					page:this.currentPage,
					userId:this.userId,
					type:this.type,
					shopId:this.shopeeIdvlue
				 }
				 console.log(params)
				 this.getProblemorder(params)
			
			 		
			 },

			 cancel(n){
				 const ttp={
					 buyer:this.$t("other.a849"),
					 system:this.$t("other.a850"),
				 }
				 return ttp[n]
			 },
			 getCancelByreason(n){
				 const ttp={
					 "Seller is not responsive to my inquiries":this.$t("other.a851"),
					 "SYSTEM_UNPAID" : this.$t("other.a852"),
					 "Others / change of mind" : this.$t("other.a853"),
					 "LOST_PARCEL" : this.$t("other.a854"),
					 "BACKEND_SELLER_DID_NOT_SHIP":this.$t("other.a855"),
					 "UNDELIVERABLE_AREA":this.$t("other.a856"),
					 "BACKEND_LOGISTICS_NOT_STARTED":"BACKEND_LOGISTICS_NOT_STARTED",
					 "LOGISTICS_PICKUP_FAILED":"LOGISTICS_PICKUP_FAILED",
					 "LOGISTICS_DELIVERY_FAILED":"LOGISTICS_DELIVERY_FAILED",
					 "Modify existing order (colour, size, address, voucher, etc.)":"Modify existing order (colour, size, address, voucher, etc.)",
					 "PHYSICAL_DMG":this.$t("other.a857"),
					 "FUNCTIONAL_DMG":this.$t("other.a858"),
					 "WRONG_ITEM":this.$t("other.a859"),
					 "NOT_RECEIPT":this.$t("other.a860")
				 }
				if(!n){
					return this.$t("other.a354")
				}else{
					return ttp[n]
				}
				 
				 
			 },
			
		}
	}
</script>

<style scoped>
	/* .returnOrders{
		flex: 1;
		margin: 60px 0 0 235px;
		
	} */

   .returnOrders .Pager{
		position: fixed;
		bottom: 0;
		left: 210px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}

	.returnOrders .list_desc{
		border-bottom: 1px solid #eee;
		background-color: #eee;
	}
	
	.returnOrders .nodata{
		width: 100%;
		text-align: center;
		margin-top: 160px;
	}

	.returnOrders .skuname{
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
	
	.returnOrders .filterbox {
	    display: flex;
	    flex-wrap: wrap;
		flex: 1;
	}

	.returnOrders .order-list-item{
		border: 1px solid #eee;
		margin-bottom: 15px;
	}
	
	.returnOrders .storeBox{
		border: 1px solid #eee;
		box-sizing: border-box;
		padding: 6px 15px ;
		font-size: 14px;
		cursor: pointer;
		margin:0 2px;
		
	}
	
	.returnOrders .filterbox {
	    display: flex;
	    flex-wrap: wrap;
		flex: 1;
	}
	.returnOrders .filterbox {
	    display: flex;
	    flex-wrap: wrap;
		flex: 1;
	}
	
	.returnOrders  .ttpactive{
		background-color: #1890ff;
		color: #fff;
	}
	.returnOrders  .ttpactive:hover{
		background-color: #40a9ff;
		color: #fff;
	}

	.returnOrdersreturnOrders .order-pic {
		width: 80px;
		height: 80px;
	}

	img {
		width: 100%;
		height: 100%;
	}

	.returnOrders .order-wrapper{
		margin-bottom: 50px;
	}
	
	.returnOrders .seller-img{
		display: inline-block;
		width: 50px;
		height: 50px;
	
	}
	.returnOrders .seller{
		display: inline-block;
		margin: 5px 15px;
	}
	
		
		.returnOrders .pic-box{
		 display:inline-block;
		 width: 100px;
		 height: 100px;
		}
		.returnOrders .return-item{
			display: flex;
			justify-content: space-between;
		}
		.returnOrders .return-item-list{
			display: flex;
			justify-content: space-between;
			box-sizing: border-box;
			padding: 10px 10px 10px 15px;
		}

		.returnOrders .block{
			padding-bottom: 15px;
			border-bottom: 1px #eee solid;
		}

		.returnOrders .item_desc_ppdf{
			width: 100%;
			text-overflow: ellipsis;
			color: red;
			
		}

		.returnOrders .item_desc{
			box-sizing: border-box;
			padding: 0 10px;
		}
		
		
		
		
		.returnOrders .pic-box-desc{
			width: 345px;
			padding-left: 10px;
		}
		.returnOrders .retrun-reasonr-btn{
			display: flex;
			width: 150px;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin-right: 30px;
		}
		
		.returnOrders .retrun-reasonr{
			
			box-sizing: border-box;
			padding: 10px;
		
		}
	    .vue-directive-image-previewer{
			z-index: 9999 !important;
		}
	
		.returnOrders .ban{
			width: 250px;
			overflow: hidden;
		}
		
	
	
</style>
